<template>
    <div class="inline-block">
        <div class="flex items-center">
            <button
                @click="decrement()"
                type="button"
                class="inline-flex items-center p-1.5 border rounded-full shadow border-gray-300 text-gray-500 bg-white hover:bg-gray-100 focus:outline-hidden"
            >
                <fa :icon="['fal', 'minus']" class="block h-4 w-4" />
            </button>

            <input
                type="number"
                @change="updateManual"
                v-model="quantity"
                :min="min"
                :max="max"
                pattern="^[0-9\-\+\s\(\)]*$"
                class="w-14 py-1 border-gray-300 rounded-lg transition focus:border-indigo-300 focus:ring-3 focus:ring-indigo-200/50 hide-arrows mx-2 font-bold text-xl text-center"
            />
            <!-- <span class="inline-block mx-4">{{ quantity }}</span> -->
            <!-- <button @click="increment()">&#xff0b;</button> -->
            <button
                @click="increment()"
                type="button"
                class="inline-flex items-center p-1.5 border rounded-full shadow border-gray-300 text-gray-500 bg-white hover:bg-gray-100 focus:outline-hidden"
            >
                <fa :icon="['fal', 'plus']" class="block h-4 w-4" />
            </button>
        </div>
    </div>
</template>

<script setup>
import { getCurrentInstance, ref, watch } from 'vue';

const props = defineProps({
    qty: [Number, String],
    min: {
        type: [Number, String],
        default: 0
    },
    max: {
        type: [Number, String],
        default: 100
    },
    updateParent: Boolean,
    default: {
        type: Number,
        default: 0
    }
});

const emit = defineEmits(['update:qty']);

const quantity = ref(props.qty ? parseFloat(props.qty) : props.default);

function updateManual() {
    if (typeof quantity.value === 'number') {
        if (quantity.value > parseFloat(props.max)) {
            quantity.value = 100;
        }
        update();
    } else {
        quantity.value = props.qty;
    }
}

function increment() {
    if (quantity.value < parseFloat(props.max)) quantity.value++;
    update();
}

function decrement() {
    if (quantity.value > parseFloat(props.min)) {
        quantity.value--;
    }
    update();
}

function update() {
    emit('update:qty', quantity.value);
    if (props.updateParent) {
        // Access parent component in composition API
        const parent = getCurrentInstance();
        if (parent && typeof parent.updateQty === 'function') {
            parent.updateQty(quantity.value);
        }
    }
}

// Watch for prop changes
watch(() => props.qty, (newValue) => {
    if (newValue !== undefined) {
        quantity.value = parseFloat(newValue);
    }
});
</script>
